import type { MeDto } from '@penalty-cup/shared';
import { kitById } from '@penalty-cup/shared';
import { useState } from 'react';
import { Jersey } from './Jersey.js';

/** Фото Telegram (или инициалы на цвете формы) со значком формы. */
export function Avatar({ me, size = 48 }: { me: MeDto; size?: number }) {
  // Фото не загрузилось (нет сети, удалено) — показываем инициалы на цвете формы
  const [photoFailed, setPhotoFailed] = useState(false);
  // Инициалы — первые буквы двух первых слов («Северное Сияние» → «СС»), у одного слова — две буквы
  const words = (me.teamName ?? me.firstName).split(' ').filter(Boolean);
  const initials = (
    words.length > 1 ? words[0]![0]! + words[1]![0]! : (words[0] ?? '?').slice(0, 2)
  ).toUpperCase();
  const style = { width: size, height: size };
  return (
    <span className="avatar-wrap">
      {me.photoUrl && !photoFailed ? (
        <img className="avatar" style={style} src={me.photoUrl} alt="" onError={() => setPhotoFailed(true)} />
      ) : (
        <span
          className="avatar"
          style={{ ...style, background: kitById(me.kit).color, color: kitById(me.kit).accent }}
        >
          {initials}
        </span>
      )}
      <Jersey kit={me.kit} className="avatar-wrap__kit" />
    </span>
  );
}
